import { Phone, ArrowUpRight } from "lucide-react";
import { BUSINESS } from "@/lib/site";
import { useGoToQuote } from "@/lib/quoteNav";

/** Fixed bottom bar on mobile only — Call Now + Get a Quote. */
export function StickyMobileBar() {
  const goQuote = useGoToQuote();
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-primary/20 bg-primary text-primary-foreground shadow-[0_-10px_30px_-18px_rgba(0,0,0,0.5)] lg:hidden">
      <a
        href={BUSINESS.phoneHref}
        className="flex items-center justify-center gap-2 py-3.5 text-sm font-semibold"
      >
        <Phone className="h-4 w-4" /> Call Now
      </a>
      <button
        type="button"
        onClick={goQuote}
        className="flex items-center justify-center gap-2 border-l border-primary-foreground/15 py-3.5 text-sm font-semibold"
      >
        <ArrowUpRight className="h-4 w-4" /> Get a Quote
      </button>
    </div>
  );
}
